function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#10755A",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M10.2 7.963l.175.024.113.038.075.05.062.063.063.1.087.2.1.312.137.463.075.275-.15-.025-.274-.025-.263.012-.263.05-.287.063-.325.1-.35.112-.363.15-.35.162-.362.175-.35.2-.325.2-.35.225-.338.263-.3.225-.275.25-.262.275-.275.3-.225.3-.188.313-.15.312-.087.275-.012.25.012.2.075.175.1.162.15.138.175.113.213.087.3.075.437.05.288.012.324-.025.4-.024.438-.038.488-.075.524-.088.55-.112.575-.138.563-.162.588-.2.6-.213.612-.262.662-.3.738-.363.813-.412.012-.012-.987-2.45-1.525 3.187-.05.1-.088.088-.075.075-.2.1-.238.075-.312.112-.325.1-.3.088-.313.062-.3.063-.274.037-.125.025-.113.012 3.188-5.862H14.8l1.525 3.262.175-.087 1.1-.612 1.175-.663L20 9.25v1.738l-1.45.8-1.313.737-.274.15 1.624 3.5H16.45l-.087-.025-.063-.025-.075-.038-.063-.05-.05-.05-.037-.062-.025-.075-.888-2.188-.45.25-.412.213-.3.162-.225.125-.4.188-.375.188-.375.15-.363.15-.375.137-.362.138-.363.112-.362.1-.363.113-.324.074-.35.088-.363.075-.363.063-.362.05-.375.024-.425.025-.438-.012-.45-.037-.437-.088-.4-.112-.338-.113-.287-.15-.263-.175-.237-.2-.225-.237-.2-.263-.162-.262-.138-.3-.125-.325-.087-.35-.063-.338L4 12.787l.025-.3.075-.312.113-.313.15-.312.174-.288.213-.287.213-.262.487-.488.275-.225.313-.25.362-.25.35-.25.35-.213.338-.187.35-.188.35-.162.374-.162L8.9 8.2l.375-.112.362-.075.313-.038.25-.012zm9.8-.888v1.462l-3.012 1.65-.026.026-.062.025-.063.024-.1.013h-.1l-.1-.025-.1-.063-.125-.1-.125-.15-.112-.175-.1-.2-.075-.187-.063-.188-.024-.1.024.013.05.025.075.025.063.012h.075l.087-.025.075-.024.038-.025L20 7.075z"
}));

var SvgIcCacib = function SvgIcCacib(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCacib, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_cacib.2df7ba3a.svg";
export { ForwardRef as ReactComponent };